import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as RefreshCWIcon } from './refreshCW.svg';

export const RefreshCW = IconHOC(RefreshCWIcon);
